import React from 'react';
import {Button} from "reactstrap";

const Colleaguebutton = (props) => {
    const onClick = (link) =>{
        window.open(link,'_blank')
    }
    return(
        <>           
            <button onClick={()=>onClick(props.link)} className={'Colleaguebutton'}
            ><img src={props.image} /></button>
        </>
    )
};

export default Colleaguebutton;